import React, { createContext, useContext } from 'react';

const SessionContext = createContext({});

export function SessionProvider({ children }) {
  return <SessionContext.Provider value={{}}>{children}</SessionContext.Provider>;
}

export function useSession() {
  return useContext(SessionContext);
}
